// import AccessManagement from '../screens/AccessManagement'
import AuditLogsForm from '../screens/AuditLogsForm'
import Forbidden from '../screens/Forbidden'
import Home from '../screens/Home'
import Settings from '../screens/Settings'
import accessManagementPagesRoleManagement from './accessManagementRoleManagement'
import accommodationPagesRoleManagement from './accommodationsRoleManagement'
import adminConfigRoleManagement from './adminConfigRoleManagement'
import bookingRoleManagement from './bookRoleManagement'
import cancelPolicyPagesRoleManagement from './cancelPolicyRoleManagement'
import channelPagesRoleManagement from './channelPagesRoleManagement'
import contractPagesRoleManagement from './contractRoleManagement'
import gatewayPagesRoleManagement from './gatewayRoleManagement'
import inventoryPagesRoleManagement from './inventoryRoleManagement'
import monitoringRoleManagement from './monitoringRoleManagement'
import notificationRoleManagement from './notificationRoleManagement'
import priceClassRoleManagement from './priceClassRoleManagement'
import promotionRoleManagement from './promotionRoleManagement'
import providerRoleManagement from './providerRoleManagement'
import ratePlanPagesRoleManagement from './ratePlanRoleManagement'
import roomTypePagesRoleManagement from './roomTypeRoleManagement'
import sitekeyPagesRoleManagement from './sitekeyRoleManagement'
import supportRoleManagement from './supportRoleManagement'
import tenantPagesRoleManagement from './tenantRoleManagement'
import { allRoles, ROLE, RouteWithAccessType } from './types'
import walletPagesRoleManagement from './walletRoleManagement'

export const RoleAccessManagement: RouteWithAccessType[] = [
  ...accommodationPagesRoleManagement,
  ...roomTypePagesRoleManagement,
  ...ratePlanPagesRoleManagement,
  ...channelPagesRoleManagement,
  ...cancelPolicyPagesRoleManagement,
  ...contractPagesRoleManagement,
  ...tenantPagesRoleManagement,
  ...inventoryPagesRoleManagement,
  ...gatewayPagesRoleManagement,
  ...sitekeyPagesRoleManagement,
  ...monitoringRoleManagement,
  ...notificationRoleManagement,
  ...adminConfigRoleManagement,
  ...bookingRoleManagement,
  ...accessManagementPagesRoleManagement,
  ...providerRoleManagement,
  ...promotionRoleManagement,
  ...priceClassRoleManagement,
  ...walletPagesRoleManagement,
  ...supportRoleManagement,
  {
    // Reachable by everyone, deliberately. Fifteen screens redirect here when a tab or
    // section refuses access, and the Switch has no catch-all — so before this route
    // existed every one of those redirects rendered nothing and the page went blank.
    // Requiring a feature to see the page that explains a denial would restore that.
    //
    // The redirects target the unprefixed `/403`; localizedPaths registers `/403`,
    // `/en/403` and `/fa/403`, so all three match.
    route: '/403',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    requiredFeatures: [],
    component: <Forbidden />
  },
  {
    route: '/home',
    exact: false,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    requiredFeatures: [],
    component: <Home />
  },
  {
    route: '/settings',
    exact: false,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    requiredFeatures: ['settings.view'],
    component: <Settings />
  },
  // {
  //   route: '/access-management',
  //   exact: true,
  //   rolesListWithReadAccess: [ROLE.ADMIN],
  //   rolesListWithWriteAccess: [ROLE.ADMIN],
  //   component: <AccessManagement />
  // },
  {
    route: '/audit-logs',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN, ROLE.PROVIDER, ROLE.TENANT],
    rolesListWithWriteAccess: [ROLE.ADMIN, ROLE.PROVIDER, ROLE.TENANT],
    requiredFeatures: ['audit.logs.view'],
    component: <AuditLogsForm />
  }
]
